/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment';
import i18next from "i18next";
import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { WidgetLoader } from 'datastake-daf/dist/components';
import RiskTransfer from '../components/riskManagement/index';
import RiskService from '../../../../../services/RiskService';

const mapTypeOfMeasure = (measures = [], options = []) => measures.filter((m) => m.id).map((m) => {
  const option = options.find((o) => o.value === m.measure);
  return {
    ...m,
    measure: option ? option.label : m.measure,
  };
});

export function RiskManagment({
  props = {},
  optionGroup = [],
  formsValue = {},
  allFormsValue = {},
  forms = {},
  inputLabel = [],
  onValuesChange = () => { },
  measureOptions,
  locationName,
}) {
  const { pathname } = useLocation();
  const [, mod] = pathname.split(/\/app\/(pme|cadd)\/edit/);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  /*
  const TableTransfer = ({ leftColumns, rightColumns, ...restProps }) => (
    <Transfer {...restProps} showSelectAll={false}>
      {({
        direction,
        filteredItems,
        onItemSelectAll,
        onItemSelect,
        selectedKeys: listSelectedKeys,
        disabled: listDisabled,
      }) => {
        const columns = direction === 'left' ? leftColumns : rightColumns;
        const rowSelection = {
          getCheckboxProps: item => ({ disabled: listDisabled || item.disabled }),
          onSelectAll(selected, selectedRows) {
            const treeSelectedKeys = selectedRows
              .filter(item => !item.disabled)
              .map(({ key }) => key);
            const diffKeys = selected
              ? _.difference(treeSelectedKeys, listSelectedKeys)
              : _.difference(listSelectedKeys, treeSelectedKeys);
            onItemSelectAll(diffKeys, selected);
          },
          onSelect({ key }, selected) {
            onItemSelect(key, selected);
          },
          selectedRowKeys: listSelectedKeys,
        };
        if (direction === 'left') {
          filteredItems = filteredItems.map(i => {
            if (i.status === 'linked') {
              i.status = 'unlinked';
            }
            return i;
          });
        } else {
          filteredItems = filteredItems.map(i => {
            if (i.status === 'unlinked') {
              i.status = 'linked';
            }
            return i;
          });
        }

        return (
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={filteredItems}
            size="small"
            pagination={false}
            scroll={{ y: 200 }}
            style={{ pointerEvents: listDisabled ? 'none' : null }}
          // onRow={({ key, disabled: itemDisabled }) => ({
          //   onClick: () => {
          //     if (itemDisabled || listDisabled) return;
          //     onItemSelect(key, !listSelectedKeys.includes(key));
          //   },
          // })}
          />
        );
      }}
    </Transfer>
  );
  */

  useEffect(() => {
    if (allFormsValue && Object.keys(allFormsValue).length) {
      const end = moment();
      const start = moment().subtract(12, 'months');
      const startDate = start.format('YYYY-MM-DD');
      const endDate = end.format('YYYY-MM-DD');

      RiskService.getEvents({
        id: allFormsValue.id,
        params: {
          startDate,
          endDate,
          subCategory: formsValue.subCategory,
        },
      })
        .then(({ data }) => {
          setLoading(false);
          if (data && Array.isArray(data)) {
            setData(data.map((d) => ({ ...d, location: locationName })));
          }
        }).catch((e) => {
          console.log(e);
        });
    }
  }, []);

  const linkToEvent = (id) =>
    <Link target="_blank" to={`/app/${mod}/view/event/${id}`}>{id}</Link>;

  const leftTableColumns = [
    {
      dataIndex: 'datastakeId',
      title: i18next.t('Id'),
      render: (id) => linkToEvent(id),
    },
    {
      dataIndex: 'eventTitle',
      title: i18next.t('Title'),
      ellipsis: true,
      render: (value, all) => {
        return <Tooltip title={value || all.title}>{value || all.title}</Tooltip>
      }
    },
    {
      dataIndex: 'location',
      title: i18next.t('Location'),
      ellipsis: true,
      render: (value) => {
        return <Tooltip title={value}>{value}</Tooltip>
      }
    },
    {
      dataIndex: 'dateOfEvent',
      title: i18next.t('Date'),
      render: (val) => moment(val).format('DD MMM YYYY')
    },
  ];

  const rightTableColumns = [
    {
      dataIndex: 'datastakeId',
      title: i18next.t('Id'),
      render: (id) => linkToEvent(id),
    },
    {
      dataIndex: 'eventTitle',
      title: i18next.t('Title'),
      ellipsis: true,
      render: (value, all) => {
        return <Tooltip title={value || all.title}>{value || all.title}</Tooltip>
      }
    },
    {
      dataIndex: 'location',
      title: i18next.t('Location'),
      ellipsis: true,
      render: (value) => {
        return <Tooltip title={value}>{value}</Tooltip>
      }
    },
  ];

  const titles = optionGroup && Array.isArray(optionGroup) && optionGroup.length > 1 ? optionGroup.map(o => o.label) :
    [i18next.t('All Events for Risk type'), i18next.t('Relevant events for this risk type')]

  /*
return <TableTransfer
  dataSource={data}
  targetKeys={value}
  {...props}
  filterOption={(inputValue, item) =>
    item.title.indexOf(inputValue) !== -1 || item.tag.indexOf(inputValue) !== -1
  }
  onChange={(val) => {
    onChange(val);
  }}
  titles={titles}
  leftColumns={leftTableColumns}
  rightColumns={rightTableColumns}
/>
*/

  if (loading) {
    return (
      <div
        style={{
          position: 'relative',
          width: '100%',
        }}
      >
        <WidgetLoader background="transparent" />
      </div>
    )
  }

  return (
    <>
      <RiskTransfer
        events={data}
        value={formsValue.management}
        config={forms.management ? forms.management.labelmanagement || {} : {}}
        {...props}
        filterOption={(inputValue, item) =>
          item.title.indexOf(inputValue) !== -1 || item.tag.indexOf(inputValue) !== -1
        }
        inputLabel={inputLabel}
        measures={mapTypeOfMeasure([...formsValue.planning, ...formsValue.otherPlanning], measureOptions)}
        planningMeasures={formsValue.planning}
        otherPlanningMeasures={formsValue.otherPlanning}
        linkToEvent={linkToEvent}
        onChange={(val) => {
          onValuesChange({ management: val }, { ...allFormsValue, management: val }, true);
        }}
        onChangeMeasures={(val) => {
          onValuesChange({ planning: val }, { ...allFormsValue, planning: val }, true);
        }}
        onChangeOtherMeasures={(val) => {
          onValuesChange({ otherPlanning: val }, { ...allFormsValue, otherPlanning: val }, true);
        }}
        titles={titles}
        unlinkedColumns={leftTableColumns}
        linkedColumns={rightTableColumns}
      />
    </>
  );
}
